import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { language, t } = useLanguage();
  const links = [
    ['about', t.nav.about], ['programs', t.nav.program], ['sectors', t.nav.sectors],
    ['startups', t.nav.startups], ['investors', t.nav.investors], ['partners', t.nav.partners], ['contact', t.nav.contact]
  ];
  const scrollToSection = (id) => document.getElementById(id)?.scrollIntoView({ behavior:'smooth' });

  return (
    <footer className="relative bg-[#04172A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-3 gap-10">
        <div className={language === 'ar' ? 'text-right' : ''}>
          <img src="/ateed-logo.svg" alt="ATEED" className="h-20 w-auto bg-white rounded-xl p-2" />
          <p className="mt-5 text-slate-400">{t.footer.tagline}</p>
        </div>
        <div className={language === 'ar' ? 'text-right' : ''}>
          <h4 className="font-bold mb-4">{t.footer.quick}</h4>
          <div className="grid grid-cols-2 gap-2">
            {links.map(([id,label]) => <button key={id} onClick={() => scrollToSection(id)} className="text-slate-400 hover:text-white text-sm text-left">{label}</button>)}
          </div>
        </div>
        <div className={language === 'ar' ? 'text-right' : ''}>
          <h4 className="font-bold mb-4">{t.footer.contact}</h4>
          <a href="mailto:info@at33d.com" className="text-slate-400 hover:text-white">info@at33d.com</a>
          <p className="mt-3 text-slate-500 text-sm">Ras Al Khaimah, UAE</p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-sm text-slate-500 ${language === 'ar' ? 'text-right' : ''}`}>{t.footer.copyright}</div>
      </div>
    </footer>
  );
};
